import { t } from "@/i18n-js/instance";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { Icon } from "@circle-react/components/shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";

interface OpenInNewWindowLinkProps {
  postUrl: string;
  version: "minimal" | "full";
}

export const OpenInNewWindowLink = ({
  postUrl,
  version,
}: OpenInNewWindowLinkProps) => {
  if (version === "minimal") {
    return (
      <TippyV2 content={t("help_widget.tooltip.open_in_new_window")}>
        <button
          type="button"
          onClick={() => window.open(postUrl, "_blank", "noopener,noreferrer")}
          className="hover:bg-secondary text-light flex size-6 items-center rounded-full p-1"
        >
          <Icon type="share-support-widget" useWithFillCurrentColor size={16} />
        </button>
      </TippyV2>
    );
  }

  return (
    <a
      href={postUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="dark:border-secondary my-2 flex w-full justify-center gap-2 rounded-3xl border border-[#2B2E33] p-1"
    >
      <Typography.LabelSm
        weight="font-medium"
        color="text-primary"
        size="text-sm"
      >
        {t("support_widget.open_post")}
      </Typography.LabelSm>
      <Icon type="share-support-widget" useWithFillCurrentColor size={16} />
    </a>
  );
};
